import React from "react";
import { Category } from "../types/Category";

export interface ChallengeContextProps{
    challenges: Category[];
    setChallenges: (challenges: Category[]) => void;
    roundId: string;
}

export const ChallengeContext = React.createContext<ChallengeContextProps>({
    challenges: [],
    setChallenges: ()=> {},
    roundId: ''
})

export function useChallenge(){
    return React.useContext(ChallengeContext)
}